import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { DateTime } from 'luxon';
import { Observable, Subject } from 'rxjs';

import { environment } from 'environments/environment';

import { IPaginatedListViewSearchModel, PaginatedModel } from '../models/common.models';
import {
  ICmsUserDetailsModel,
  ICmsUserSearchModel,
  IUserListUserModel,
  UpdateUserModel,
} from '../models/user-management.models';
import { IRoleListRoleModel } from '../models/user-role-management.models';

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  private searchEvent = new Subject<any>();

  searchEvent$ = this.searchEvent.asObservable();

  private get baseApiUrl(): string {
    return environment.userManagementUrl;
  }

  constructor(private http: HttpClient) {}

  getCmsUsersV1(searchModel: ICmsUserSearchModel): Observable<PaginatedModel<IUserListUserModel>> {
    const url = `${this.baseApiUrl}/v1/cmsusers`;
    let params = new HttpParams()
      .append('filterText', searchModel.searchText)
      .append('orderByColumn', searchModel.orderByColumn)
      .append('orderByDirection', searchModel.orderByDirection)
      .append('page', searchModel?.page?.toString() === 'NaN' ? '1' : searchModel?.page?.toString())
      .append('pageSize', searchModel?.pageSize?.toString() ?? 20);

    if (searchModel.filters) {
      for (const filter in searchModel.filters) {
        if (searchModel.filters[filter]) {
          for (const value of searchModel.filters[filter]) {
            let formattedValue;
            //Check if its a date range
            value instanceof DateTime ? (formattedValue = value.toISODate()) : (formattedValue = value.id.toString());
            params = params.append('filter.' + filter, formattedValue);
          }
        }
      }
    }

    if (searchModel.status) {
      params = params.append('status', searchModel.status);
    }

    return this.http.get<PaginatedModel<IUserListUserModel>>(url, {
      params,
    });
  }

  lockUserV1(id: string): Observable<any> {
    const url = `${this.baseApiUrl}/v1/cmsusers/${id}/lock`;
    return this.http.post<any>(url, {});
  }

  unlockUserV1(id: string): Observable<any> {
    const url = `${this.baseApiUrl}/v1/cmsusers/${id}/unlock`;
    return this.http.post<any>(url, {});
  }

  getCmsUserV1(id: string): Observable<ICmsUserDetailsModel> {
    const url = `${this.baseApiUrl}/v1/cmsusers/${id}`;
    return this.http.get<ICmsUserDetailsModel>(url, {});
  }

  updateUserV1(id: string, model: UpdateUserModel): Observable<any> {
    const url = `${this.baseApiUrl}/v1/cmsusers/${id}`;
    return this.http.put<any>(url, model);
  }
}
